// dependecies import ==>
import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ClickAwayListener } from "@material-ui/core";
import moment from "moment";
// assets and scss import ==>
import "./myTransactionsView.scss";
import dropdownArrow from "../../assets/dropdown_blue.svg";
import blackTick from "../../assets/tick-thin.svg";
import blueTick from "../../assets/tick-thin-blue.svg";
// project file import ==>
import Finance from "../Finance/Finance";
import Loader from "../UI Component/Loader/Loader";
import MyTransactionsHeader from "./MyTransactionsHeader";
import DoctorContext from "../ClinicComponents/ClinicWrapper/DoctorContext";
import DownloadReport from "../DownloadReport/DownloadReport";
import {
  addQuery,
  removeQuery,
  getTransactionFilterFromLocalStorage,
  removeTransactionFilterFromLocalStorage,
} from "./helper";
import useWindowSize from "../../Hooks/useWindowSize";
import DayCollectionView from "./DayCollectionView";
import MyTransactionsMainContent from "./MyTransactionsMainContent";
import SearchBarWithIcon from "../common/Modules/SearchBarWithIcon";
import SelectDoctorDesktopView from "../ClinicComponents/CommonComponents/SelectDoctorModal/SelectDoctorDesktopView";
import SelectDoctorMobileView from "../ClinicComponents/CommonComponents/SelectDoctorModal/SelectDoctorMobileView";
// constant import ==>
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { c2cPostApiHandler } from "../../Util/c2cApiHandler";
import {
  DOWNLOAD_DAY_COLLECTION,
  DOWNLOAD_STAFF_REPORT_API,
  DOWNLOAD_TRANSACTIONS_REPORT_API,
  GET_ALL_PROCEDURES_API,
  GET_DOCTOR_TRANSACTIONS_DATA,
  GET_STAFF_TRANSACTIONS_DATA,
} from "./MyTransactionsApiHandler/ApiConstants";
import { USER_ROLE, USER_TYPE } from "../../Util/constants";
import {
  API_FILTER_LIST,
  DEFAULT_TRANSACTIONS_PAYLOAD,
  DOWNLOAD_REPORT_TYPE,
  TRANSACTION_DROPDOWN,
} from "./constants";
import { getProcedureForConsultationFilter } from "./MyTransactionsApiHandler";

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}

const MyTransactionsView = () => {
  const size = useWindowSize();
  const history = useHistory();
  const location = useLocation();
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);

  const doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  const staffClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION
  );
  const selectedClinic = localStorage.getItem(
    LOCALSTORAGEKEY.SELECTED_CLINIC_DETAILS
  );
  const selectedDoctorId = new URLSearchParams(location.search).get(
    API_FILTER_LIST.DOCTORNAME
  );
  const sortOrder = new URLSearchParams(location.search).get(
    API_FILTER_LIST.SORTORDER
  )
    ? new URLSearchParams(location.search).get(API_FILTER_LIST.SORTORDER)
    : DEFAULT_TRANSACTIONS_PAYLOAD.sort_order;

  const searchString = new URLSearchParams(location.search).get(
    API_FILTER_LIST.SEARCHSTRING
  )
    ? new URLSearchParams(location.search).get(API_FILTER_LIST.SEARCHSTRING)
    : DEFAULT_TRANSACTIONS_PAYLOAD.search_string;

  const pageNo = new URLSearchParams(location.search).get(
    API_FILTER_LIST.PAGENO
  )
    ? new URLSearchParams(location.search).get(API_FILTER_LIST.PAGENO)
    : DEFAULT_TRANSACTIONS_PAYLOAD.page_no;

  const consultationTypeValue = new URLSearchParams(location.search).get(
    API_FILTER_LIST.CONSULTATION_TYPE
  )
    ? new URLSearchParams(location.search).get(
        API_FILTER_LIST.CONSULTATION_TYPE
      )
    : DEFAULT_TRANSACTIONS_PAYLOAD.consultation_filter;

  const paymentStatus = new URLSearchParams(location.search).get(
    API_FILTER_LIST.PAYMENT_STATUS
  )
    ? new URLSearchParams(location.search).get(API_FILTER_LIST.PAYMENT_STATUS)
    : DEFAULT_TRANSACTIONS_PAYLOAD.payment_status;

  const paymentMethodValue = new URLSearchParams(location.search).get(
    API_FILTER_LIST.PAYMENT_METHOD_VALUE
  )
    ? new URLSearchParams(location.search).get(
        API_FILTER_LIST.PAYMENT_METHOD_VALUE
      )
    : DEFAULT_TRANSACTIONS_PAYLOAD.payment_method_filter;

  const partialAmountValue = new URLSearchParams(location.search).get(
    API_FILTER_LIST.AMOUNT_VALUE
  )
    ? new URLSearchParams(location.search).get(API_FILTER_LIST.AMOUNT_VALUE)
    : DEFAULT_TRANSACTIONS_PAYLOAD.partial_amount_filter;

  const procedureTypeFilterValue = new URLSearchParams(location.search).get(
    API_FILTER_LIST.PROCEDURE_VALUE
  )
    ? new URLSearchParams(location.search).get(API_FILTER_LIST.PROCEDURE_VALUE)
    : DEFAULT_TRANSACTIONS_PAYLOAD.procedure_type_filter;

  const startDate = new URLSearchParams(location.search).get(
    API_FILTER_LIST.STARTDATE
  )
    ? new URLSearchParams(location.search).get(API_FILTER_LIST.STARTDATE)
    : DEFAULT_TRANSACTIONS_PAYLOAD.start_date;

  const endDate = new URLSearchParams(location.search).get(
    API_FILTER_LIST.ENDDATE
  )
    ? new URLSearchParams(location.search).get(API_FILTER_LIST.ENDDATE)
    : DEFAULT_TRANSACTIONS_PAYLOAD.end_date;

  const payload = DEFAULT_TRANSACTIONS_PAYLOAD;

  const doctor_context = useContext(DoctorContext);
  const [doctor_selected, setDoctorSelected] = useState([]);
  const [doctorList, setDoctorList] = useState([]);

  const downloadRef = useRef();
  const prevClinic = useRef(clinicId);

  const [loader, setLoader] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showAccountDetails, setShowAccountDetails] = useState(false);
  const [transactionsSummary, setTransactionsSummary] = useState({
    noOfTransactions: 0,
    totalAmount: 0,
    pendingAmount: 0,
    partialAmount: 0,
    partialAmtCount: 0,
  });
  const [disableDownload, setDisableDownload] = useState(false);
  const [doctorSelectModal, setDoctorSelectModal] = useState(false);
  const [showMobileView, setShowMobileView] = useState(false);
  const [downloadReport, setDownloadReport] = useState([]);
  const [selectedDropdownValue, setSelectedDropdownValue] =
    useState("My Transactions");
  const debouncedSearchTerm = useDebounce(searchString, 500);
  const [transactionsData, setTransactionsData] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [procedureList, setProcedureList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecordsCount, setTotalRecordsCount] = useState([]);
  const [transactionDownloadOption, setTransactionDownloadOption] =
    useState(DOWNLOAD_REPORT_TYPE);
  const [disableDayCollectionDownload, setDisableDayCollectionDownload] =
    useState(false);

  // Lifecycle Methods ===>

  useEffect(() => {
    const transactionFilters = getTransactionFilterFromLocalStorage();
    if (!transactionFilters) {
      localStorage.removeItem("transactionDefaultDate");
    }
    if (userType !== USER_TYPE.STAFF) {
      if (
        !doctorRole ||
        doctorRole === USER_ROLE.DOCTOR_CONSULTANT ||
        doctorRole === USER_ROLE.RESOURCE_CONSULTANT
      ) {
        let params = {};
        if (prevClinic.current === clinicId) {
          const transactionFilters = getTransactionFilterFromLocalStorage();
          if (transactionFilters) {
            let params_arr = transactionFilters?.split("&");
            params_arr.forEach((pa) => {
              params[pa?.split("=")[0]] = pa?.split("=")[1];
            });
          }
        }
        callApi(params);
      }
    }

    if (
      localStorage.getItem("TransDisableDownload") &&
      localStorage.getItem("TransDisableDownload") === "true"
    ) {
      setDisableDownload(true);
    } else {
      setDisableDownload(false);
    }

    if (
      localStorage.getItem("DayCollectionDisableDownload") &&
      localStorage.getItem("DayCollectionDisableDownload") === "true"
    ) {
      setDisableDayCollectionDownload(true);
    } else {
      setDisableDayCollectionDownload(false);
    }
    setShowLoader(true);
  }, []);

  useEffect(
    () => {
      if (debouncedSearchTerm.length) {
        getTransactions(
          {
            [API_FILTER_LIST.SEARCHSTRING]: debouncedSearchTerm,
            [API_FILTER_LIST.PAGENO]: DEFAULT_TRANSACTIONS_PAYLOAD.page_no,
          },
          true
        );
      }
    },
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  useEffect(() => {
    if (
      doctor_selected.length > 0 &&
      (userType === USER_TYPE.STAFF ||
        doctorRole === USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN)
    ) {
      callApi();
    } // with doctor ids itself getting called twice for admin doc
  }, [doctor_selected]);

  useEffect(() => {
    let arr = [],
      arr1 = [];
    doctor_context.selectedDoctor.length > 0 &&
      doctor_context.selectedDoctor.forEach((data) => {
        if (data?.selected === true) {
          arr.push(data.doctor_id);
          arr1.push(data);
        }
      });
    setDoctorSelected(arr);
    setDoctorList(arr1);
  }, [doctor_context.selectedDoctor]);

  useEffect(() => {
    if (prevClinic.current !== clinicId) {
      prevClinic.current = clinicId;
      history.replace(
        `${location.pathname}` +
          `?${[API_FILTER_LIST.STARTDATE]}=${moment().format("YYYY-MM-DD")}&${[
            API_FILTER_LIST.ENDDATE,
          ]}=${moment().format("YYYY-MM-DD")}`
      );
      localStorage.setItem(
        "transactionFilters",
        `${[API_FILTER_LIST.STARTDATE]}=${moment().format("YYYY-MM-DD")}&${[
          API_FILTER_LIST.ENDDATE,
        ]}=${moment().format("YYYY-MM-DD")}`
      );
      if (
        userType !== USER_TYPE.STAFF &&
        doctorRole !== USER_ROLE.DOCTOR_ADMIN &&
        doctorRole !== USER_ROLE.RESOURCE_ADMIN
      ) {
        handleClinicChange();
      }
    } else {
      const transactionFilters = getTransactionFilterFromLocalStorage();
      if (transactionFilters) {
        history.replace(`${location.pathname}?${transactionFilters}`);
        localStorage.setItem("transactionFilters", transactionFilters);
      }
    }
  }, [clinicId]);

  // <===

  // Helper Methods ===>

  const callApi = (data) => {
    let params = {
      [API_FILTER_LIST.STARTDATE]: startDate
        ? startDate
        : DEFAULT_TRANSACTIONS_PAYLOAD.start_date,
      [API_FILTER_LIST.ENDDATE]: endDate
        ? endDate
        : DEFAULT_TRANSACTIONS_PAYLOAD.end_date,
    };
    if (!localStorage.getItem("transactionDefaultDate")) {
      params = {
        [API_FILTER_LIST.STARTDATE]: moment().format("YYYY-MM-DD"),
        [API_FILTER_LIST.ENDDATE]: moment().format("YYYY-MM-DD"),
      };
      addQuery(
        history,
        location,
        [API_FILTER_LIST.STARTDATE, API_FILTER_LIST.ENDDATE],
        [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]
      );
      localStorage.setItem("transactionDefaultDate", "true");
    }
    getTransactions({ ...params, ...data });
    getConsultationTypeProceduresAPI();
  };

  const getIds = (data) => {
    let ids = null;
    let selectedId = selectedDoctorId ? [selectedDoctorId] : doctor_selected;
    if (data?.doctor_ids !== "") {
      ids = data?.doctor_ids ? [data?.doctor_ids] : selectedId;
    } else {
      ids = doctor_selected;
    }
    return ids;
  };

  const getDoctorIds = (data) => {
    let doc_ids = {};
    let dIds = getIds(data);
    if (userType === USER_TYPE.STAFF) {
      doc_ids.doctor_ids = dIds ? dIds : doctor_selected;
    } else if (clinicId) {
      if (
        doctorRole === USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN
      ) {
        let ids = doctor_selected?.length > 0 ? doctor_selected : doc_ids;
        doc_ids.doctor_ids = dIds ? dIds : ids;
      } else {
        doc_ids.doctor_ids = [userId];
      }
    } else {
      doc_ids.doctor_id = userId;
    }
    return doc_ids;
  };

  const getFilterPayload = (data) => {
    return {
      ...payload,
      sort_order: data?.sort_order ? data?.sort_order : sortOrder,
      search_string:
        data?.search_string || data?.search_string === ""
          ? data?.search_string
          : searchString,
      page_no: data?.page_no ? data?.page_no : pageNo,
      page_number: data?.page_no ? data?.page_no : pageNo,
      payment_method_filter: data?.payment_method_value
        ? data?.payment_method_value
        : paymentMethodValue,
      partial_amount_filter:
        data?.partial_amount_value || data?.partial_amount_value == ""
          ? data?.partial_amount_value
          : partialAmountValue,
      payment_status: data?.payment_status
        ? data?.payment_status?.toLowerCase()
        : paymentStatus?.toLowerCase(),
      payment_status_filter: data?.payment_status
        ? data?.payment_status?.toLowerCase()
        : paymentStatus?.toLowerCase(),
      procedure_type_filter:
        data?.procedure_type_filter_value ||
        data?.procedure_type_filter_value === ""
          ? data?.procedure_type_filter_value
          : procedureTypeFilterValue,
      consultation_filter:
        data?.consultation_type || data?.consultation_type === ""
          ? data?.consultation_type
          : consultationTypeValue,
      start_date:
        data?.start_date || data?.start_date === ""
          ? data?.start_date
          : startDate,
      end_date:
        data?.end_date || data?.end_date === "" ? data?.end_date : endDate,
    };
  };

  const checkStaffHasAllPermission = () => {
    let selectedClinicDetails = selectedClinic
      ? JSON.parse(selectedClinic)
      : {};
    if (userType === USER_TYPE.STAFF) {
      if (clinicId) {
        if (
          Object.keys(selectedClinicDetails)?.length > 0 &&
          Object.keys(selectedClinicDetails)?.includes("permission_set") &&
          Object.keys(selectedClinicDetails?.permission_set)?.length > 0 &&
          Object.keys(selectedClinicDetails?.permission_set)?.includes(
            "clinictransactionreport"
          )
        ) {
          return (
            selectedClinicDetails?.permission_set
              ?.clinictransactionreport[0] === 1 &&
            selectedClinicDetails?.permission_set
              ?.clinictransactionreport[1] === 1
          ); // if permission set has enabled or disabled
        }
        return true; //has clinic id and not updated permission set by default staff has all access
      }
      return true; //if virtual clinic doctor call staff api
    }
    return true; //if doctor
  };
  // <===

  // Api Calls ===>

  const getTransactions = (data, hideLoaderWhileSearch) => {
    if (!hideLoaderWhileSearch) {
      if (
        (userType !== USER_TYPE.STAFF &&
          doctorRole !== USER_ROLE.DOCTOR_ADMIN &&
          doctorRole !== USER_ROLE.RESOURCE_ADMIN) ||
        showLoader
      ) {
        setLoader(true);
      } else {
        setShowLoader(false); // avoiding two loaders
        setLoader(true);
      }
    }

    let ids = getDoctorIds(data);
    let filterPayload = getFilterPayload(data);
    let reqPayload = {
      ...filterPayload,
      ...ids,
      staff_id: staffId,
      clinic_id: clinicId,
    };
    let api = !checkStaffHasAllPermission()
      ? GET_STAFF_TRANSACTIONS_DATA
      : GET_DOCTOR_TRANSACTIONS_DATA;
    const resData = c2cPostApiHandler(api, reqPayload); //Fetch API Data
    resData.then(([res, error]) => {
      if (!error) {
        if (res && res.data && res.data.result) {
          setTransactionsData(res.data.result);
          setCurrentPage(res.data.current_page_no);
          setTotalRecordsCount(+res.data.total_rows);
          let totalAmt =
            res.data.total_success_amount &&
            res.data.total_success_amount !== ""
              ? parseFloat(res.data.total_success_amount)
              : 0;
          let pendingAmt =
            res.data.total_process_amount &&
            res.data.total_process_amount !== ""
              ? parseFloat(res.data.total_process_amount)
              : 0;
          let partialAmt =
            res.data.total_partial_amount &&
            res.data.total_partial_amount !== ""
              ? parseFloat(res.data.total_partial_amount)
              : 0;
          setTransactionsSummary({
            noOfTransactions: res.data.total_rows,
            totalAmount: totalAmt,
            pendingAmount: pendingAmt,
            partialAmount: partialAmt,
            partialAmtCount: res.data.partial_count,
          });
        } else {
          setTransactionsData([]);
          setCurrentPage(0);
          setTotalRecordsCount(0);
          setTransactionsSummary({
            noOfTransactions: 0,
            totalAmount: 0,
            pendingAmount: 0,
            partialAmount: 0,
            partialAmtCount: 0,
          });
        }
        setLoader(false);
      } else {
        setLoader(false);
      }
      setShowLoader(false);
    });
  };

  const getConsultationTypeProceduresAPI = () => {
    let reqPayload = {
      clinic_id: clinicId,
    };
    if (
      doctorRole === USER_ROLE.DOCTOR_ADMIN ||
      doctorRole === USER_ROLE.RESOURCE_ADMIN ||
      userType === USER_TYPE.STAFF
    ) {
      reqPayload["doctor_ids"] = selectedDoctorId
        ? [selectedDoctorId]
        : doctor_selected;
    } else {
      reqPayload["doctor_ids"] = [userId];
    }
    const consultationTypeResponse = getProcedureForConsultationFilter(
      reqPayload,
      GET_ALL_PROCEDURES_API
    );
    consultationTypeResponse.then(([res, error]) => {
      if (!error) {
        if (res) {
          setProcedureList(res);
        }
      }
    });
  };

  const downloadReportApi = () => {
    let selectedReport = transactionDownloadOption.filter(
      (data) => data?.selected
    );
    let reportType = selectedReport?.length > 0 ? selectedReport[0]?.value : "";
    let ids = getDoctorIds();
    let filterPayload = getFilterPayload();
    let reqPayload = {
      report_type: reportType, // "transactions",
      user_type: userType,
      payload: {
        ...filterPayload,
        ...ids,
        multiple_doctors:
          userType === USER_TYPE.STAFF ||
          doctorRole === USER_ROLE.DOCTOR_ADMIN ||
          doctorRole === USER_ROLE.RESOURCE_ADMIN,
        is_all_data: true,
        staff_id: staffId,
        clinic_id: clinicId,
        version: 1,
      },
    };
    let apiURL = !checkStaffHasAllPermission()
      ? DOWNLOAD_STAFF_REPORT_API
      : DOWNLOAD_TRANSACTIONS_REPORT_API;
    const resData = c2cPostApiHandler(apiURL, reqPayload);
    resData.then(([res, error]) => {
      if (!error) {
        if (res && res.data.message === "request published successfully") {
          downloadRef.current.showDownloadReport();
          localStorage.setItem("DownloadReport", "true");
          localStorage.setItem("TransDisableDownload", "true");
          setDisableDownload(true);
          let arr = [];
          arr = localStorage.getItem("DownloadReportArr")
            ? JSON.parse(localStorage.getItem("DownloadReportArr"))
            : [];
          arr.push({
            id: res.data.request_id,
            filename: res.data.filename,
            requestType: reportType, //"transactions",
            pause: false,
          });
          localStorage.setItem("DownloadReportArr", JSON.stringify(arr));
          setDownloadReport(arr);
        }
      }
    });
  };

  const downloadDayCollectionReportAPICall = (requestPayload) => {
    setDisableDayCollectionDownload(true);
    const resData = c2cPostApiHandler(DOWNLOAD_DAY_COLLECTION, requestPayload);
    resData.then(([res, error]) => {
      if (!error) {
        if (res && res.data.message === "request published successfully") {
          downloadRef.current.showDownloadReport();
          localStorage.setItem("DownloadReport", "true");
          localStorage.setItem("DayCollectionDisableDownload", "true");
          let arr = [];
          arr = localStorage.getItem("DownloadReportArr")
            ? JSON.parse(localStorage.getItem("DownloadReportArr"))
            : [];
          arr.push({
            id: res.data.request_id,
            filename: res.data.filename,
            requestType: "daybook_collection",
            pause: false,
          });
          localStorage.setItem("DownloadReportArr", JSON.stringify(arr));
          setDownloadReport(arr);
        }
      }
    });
  };
  // <===

  // Actions ===>

  const handleClinicChange = () => {
    getTransactions({
      ...DEFAULT_TRANSACTIONS_PAYLOAD,
      [API_FILTER_LIST.STARTDATE]: moment().format("YYYY-MM-DD"),
      [API_FILTER_LIST.ENDDATE]: moment().format("YYYY-MM-DD"),
      [API_FILTER_LIST.PAYMENT_METHOD_VALUE]:
        DEFAULT_TRANSACTIONS_PAYLOAD.payment_method_filter,
      [API_FILTER_LIST.AMOUNT_VALUE]:
        DEFAULT_TRANSACTIONS_PAYLOAD.partial_amount_filter,
      [API_FILTER_LIST.CONSULTATION_TYPE]:
        DEFAULT_TRANSACTIONS_PAYLOAD.consultation_filter,
      [API_FILTER_LIST.PROCEDURE_VALUE]:
        DEFAULT_TRANSACTIONS_PAYLOAD.procedure_type_filter,
      [API_FILTER_LIST.DOCTORNAME]: "",
      [API_FILTER_LIST.DOCTOR_NAME]: "",
    });
    getConsultationTypeProceduresAPI();
  };

  const handleDefaultPayload = () => {
    removeTransactionFilterFromLocalStorage();
    history.replace(
      `${location.pathname}` +
        `?${[API_FILTER_LIST.STARTDATE]}=${moment().format("YYYY-MM-DD")}&${[
          API_FILTER_LIST.ENDDATE,
        ]}=${moment().format("YYYY-MM-DD")}`
    );
    localStorage.setItem(
      "transactionFilters",
      `${[API_FILTER_LIST.STARTDATE]}=${moment().format("YYYY-MM-DD")}&${[
        API_FILTER_LIST.ENDDATE,
      ]}=${moment().format("YYYY-MM-DD")}`
    );
    getTransactions({
      ...DEFAULT_TRANSACTIONS_PAYLOAD,
      [API_FILTER_LIST.PAYMENT_METHOD_VALUE]:
        DEFAULT_TRANSACTIONS_PAYLOAD.payment_method_filter,
      [API_FILTER_LIST.AMOUNT_VALUE]:
        DEFAULT_TRANSACTIONS_PAYLOAD.partial_amount_filter,
      [API_FILTER_LIST.CONSULTATION_TYPE]:
        DEFAULT_TRANSACTIONS_PAYLOAD.consultation_filter,
      [API_FILTER_LIST.PROCEDURE_VALUE]:
        DEFAULT_TRANSACTIONS_PAYLOAD.procedure_type_filter,
      [API_FILTER_LIST.DOCTORNAME]: "",
      [API_FILTER_LIST.DOCTOR_NAME]: "",
    });
    getConsultationTypeProceduresAPI();
  };

  const handleAccountDetails = () => {
    setShowAccountDetails(!showAccountDetails);
  };

  const handleModal = () => {
    if (size && size.width < 786) {
      setShowMobileView(true);
    } else {
      setDoctorSelectModal(true);
    }
  };

  const handleDisableDownload = () => {
    setDisableDownload(false);
  };

  const handleDisableDayCollectionDownload = () => {
    setDisableDayCollectionDownload(false);
  };

  const inputCallBack = (val) => {
    if (val) {
      addQuery(
        history,
        location,
        [API_FILTER_LIST.SEARCHSTRING, API_FILTER_LIST.PAGENO],
        [`${val}`, DEFAULT_TRANSACTIONS_PAYLOAD.page_no]
      );
    } else {
      removeQuery(history, location, [API_FILTER_LIST.SEARCHSTRING]);
      setTimeout(() => {
        getTransactions(
          {
            [API_FILTER_LIST.SEARCHSTRING]:
              DEFAULT_TRANSACTIONS_PAYLOAD.search_string,
            [API_FILTER_LIST.PAGENO]: DEFAULT_TRANSACTIONS_PAYLOAD.page_no,
          },
          true
        );
      }, 500);
    }
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleCloseDropdown = () => {
    setShowDropdown(false);
  };

  const handleDropdownSelection = (item) => {
    setSelectedDropdownValue(item.label);
    handleCloseDropdown();
  };

  const handleSelectReportType = (item) => {
    let dropdownOption = [...transactionDownloadOption];
    dropdownOption.forEach((data) => {
      data["selected"] = data?.id === item?.id;
    });
    setTransactionDownloadOption(dropdownOption);
  };

  // <===

  // Display UI ===>

  const displaySearchFilter = () => {
    return (
      <div className="search-bar">
        <SearchBarWithIcon
          inputCallBack={(val) => inputCallBack(val)}
          search_string={searchString}
          placeholder={
            clinicId
              ? "Search by patient name, UHID, mobile number"
              : "Search by patient name or mobile number"
          }
          isClearable={true}
        />
      </div>
    );
  };

  const displayTransactionDropdown = () => {
    return (
      <div
        className="my-transactions-header-dropdown"
        style={{
          marginRight:
            (!clinicId && userType !== USER_TYPE.STAFF) ||
            doctorRole === USER_ROLE.DOCTOR_CONSULTANT ||
            doctorRole === USER_ROLE.RESOURCE_CONSULTANT
              ? "30px"
              : "",
        }}
        onClick={toggleDropdown}
      >
        <div className="my-transactions-header-dropdown-value-cont">
          <span className="my-transactions-header-dropdown-value">
            {selectedDropdownValue}
          </span>
          <span
            className={
              "my-transactions-header-dropdown-arrow " +
              (showDropdown ? "my-transactions-header-dropdown-up-arrow" : "")
            }
          >
            <img alt="" src={dropdownArrow} />
          </span>
        </div>
        <div
          className={
            "mtv-header-transactions-dropdown-hide " +
            (showDropdown ? "mtv-header-transactions-dropdown-show" : "")
          }
        >
          {showDropdown && (
            <ClickAwayListener onClickAway={handleCloseDropdown}>
              <div className="my-transactions-header-dropdown-list">
                {TRANSACTION_DROPDOWN.map((item) => (
                  <span
                    key={item.id}
                    className="my-transactions-header-dropdown-list-values"
                    onClick={() => handleDropdownSelection(item)}
                  >
                    <span className="my-transactions-header-dropdown-list-tick">
                      <img
                        alt=""
                        src={
                          item.label === selectedDropdownValue
                            ? blueTick
                            : blackTick
                        }
                      />
                    </span>
                    <span>{item.label}</span>
                  </span>
                ))}
              </div>
            </ClickAwayListener>
          )}
        </div>
      </div>
    );
  };

  const displayTransactionsHeader = () => {
    return (
      <MyTransactionsHeader
        userType={userType}
        doctorClinicAssociation={doctorClinicAssociation}
        staffClinicAssociation={staffClinicAssociation}
        doctorList={doctorList}
        selectedDropdownValue={selectedDropdownValue}
        handleModal={handleModal}
        displaySearchFilter={displaySearchFilter}
        displayTransactionDropdown={displayTransactionDropdown}
      />
    );
  };

  const displayMyTransactionsView = () => {
    return (
      <MyTransactionsMainContent
        transactionsSummary={transactionsSummary}
        userType={userType}
        clinicId={clinicId}
        sortOrder={sortOrder}
        disableDownload={disableDownload}
        doctorRole={doctorRole}
        transactionsData={transactionsData}
        procedureList={procedureList}
        doctorList={doctorList}
        selectedDoctorId={selectedDoctorId}
        consultationTypeValue={consultationTypeValue}
        procedureTypeFilterValue={procedureTypeFilterValue}
        paymentStatus={paymentStatus}
        paymentMethodValue={paymentMethodValue}
        partialAmountValue={partialAmountValue}
        startDate={startDate}
        endDate={endDate}
        currentPage={currentPage}
        totalCount={totalRecordsCount}
        loader={loader}
        transactionDownloadOption={transactionDownloadOption}
        handleAccountDetails={handleAccountDetails}
        getTransactions={getTransactions}
        downloadReportApi={downloadReportApi}
        displaySearchFilter={displaySearchFilter}
        displayTransactionDropdown={displayTransactionDropdown}
        handleDefaultPayload={handleDefaultPayload}
        handleSelectReportType={handleSelectReportType}
      />
    );
  };

  const displaySelectDoctorModal = () => {
    return (
      <>
        {doctorSelectModal && (
          <SelectDoctorDesktopView
            show={doctorSelectModal}
            onHide={() => {
              setDoctorSelectModal(false);
            }}
          />
        )}

        {showMobileView && (
          <SelectDoctorMobileView
            show={showMobileView}
            onHide={() => setShowMobileView(false)}
          />
        )}
      </>
    );
  };

  // <===

  return (
    <div className="my-transactions-view-container">
      {showAccountDetails ? (
        <Finance handleAccountDetails={handleAccountDetails} />
      ) : (
        <>
          {loader && <Loader />}
          {displayTransactionsHeader()}
          {selectedDropdownValue === "My Transactions" ? (
            displayMyTransactionsView()
          ) : (
            <DayCollectionView
              getDoctorIds={getDoctorIds}
              displayTransactionDropdown={displayTransactionDropdown}
              downloadDayCollectionReportAPICall={
                downloadDayCollectionReportAPICall
              }
              disableDayCollectionDownload={disableDayCollectionDownload}
            />
          )}
          {doctorClinicAssociation !== "true" &&
            staffClinicAssociation !== "true" &&
            userType === USER_TYPE.STAFF &&
            displaySelectDoctorModal()}
        </>
      )}
      <div>
        <DownloadReport
          ref={downloadRef}
          handleTransDisableDownload={handleDisableDownload}
          downloadReport={downloadReport}
          handleDisableDayCollectionDownload={
            handleDisableDayCollectionDownload
          }
        />
      </div>
    </div>
  );
};

export default MyTransactionsView;
